import React from 'react';
import './App.css';
import RouteLoader from './config/route/RouteLoader';
// import { Helmet } from 'react-helmet';
import { fetch_base_profile_Details } from './redux/action-creators/accountDetailsAction';
import { beneficiaryReqPayload } from "./modules/home/home.model";
import { fetch_Beneficiaries_And_Policy_Details } from './redux/action-creators/homeDetailsAction';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { ThemeProvider } from 'styled-components';
import { useEffect } from 'react';
import { theme } from './common/styles/theme';
import GlobalStyles from './common/styles/global';
import 'swiper/swiper.min.css';
import { initializeGA } from './services/ga.service';
import { Toaster } from 'react-hot-toast';
//import FreshChat from 'react-freshchat'
import { useDispatch, useSelector } from 'react-redux';
import { postToNativeApp } from './common/helpers';
import TcsFlow from './modules/UI/TcsFlow';
// import TcsFlow from './modules/UI/TcsFlow';
import history from './utils/history';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import NewHomeScreenUI from './modules/newHomeScreen/NewHomeScreenUI';
import NewHomepageUI from './modules/UI/newHomePageV2';
import MultiUserSelect from './modules/UI/multiUserLogin';
import HomePageComponent from './modules/UI/HomePageComponent';
import NotificationUI from './modules/UI/Notification';

import i18n from "./i18n";
import { setAppConfig } from './redux/store/appConfigReducer';
import { store } from './redux/store';

const appTheme = 'light';



function App() {

	const dispatch = useDispatch();
	const [key, setKey] = React.useState(0);
	const { profile_Details: profile_Details }: any = useSelector((state: any) => state.fetch_base_profile_Details);
	const loginDetailsState: any = useSelector((state) => state);
	const config = store.getState().appConfig.config;

	useEffect(() => {
		if (!profile_Details.firstName && localStorage.getItem("accessToken"))
			fetchProfileDetails()
	}, [])

	function changeFavicon(url: string) {
		let favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
	  
		if (!favicon) {
		  favicon = document.createElement("link");
		  favicon.rel = "icon";
		  document.head.appendChild(favicon);
		}
	  
		favicon.href = url;
	  }

	  const fetchAndApplyConfig = async (tpaId?: string | null) => {
		try {
			let url = "https://cdn-maven.mediassist.in/public/images/config/mayfair_config.json";
			const response = await fetch(url);
		  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
	  
		  const data = await response.json();

		  let details;
	  
		  if (tpaId) {
			// Pick the relevant TPA key
			details = data[tpaId];
			if (!details) {
			  details = data.default || {};
			}
		  } else {
			// Default domain branding
			details = data[window.location.host] 
		  }
		  
		  dispatch(setAppConfig(details));
	      changeFavicon(details?.favicon)
		  // Apply branding
		//   applyBranding(details, context);
		} catch (err) {
		  console.warn("Error fetching config:", err);
		}
	  };

	useEffect(() => {
		i18n.changeLanguage(localStorage.getItem("language"));
	}, []);

	useEffect(()=>{
	
		if(localStorage.getItem("domainName") == null){
		 fetchAndApplyConfig(null);
		}
	},[])

	
	useEffect(() => {
		const savedTpaId = localStorage.getItem("domainName");
		if (savedTpaId) {
		  // setTpaId(savedTpaId);
		  const apply = async () => {
			await fetchAndApplyConfig(savedTpaId);
		  };
		  apply();
		}
		else if(loginDetailsState?.userLoginDetails?.domainName){
		  localStorage.setItem("domainName",loginDetailsState?.userLoginDetails?.domainName);
		  const apply = async () => {
			await fetchAndApplyConfig(loginDetailsState?.userLoginDetails?.domainName);
		  };
		  apply();
		}
	  }, [loginDetailsState.userLoginDetails,dispatch]);


	const fetchProfileDetails = async () => {
		dispatch(fetch_base_profile_Details(false));
	}
	const { beneficiaryDetails: beneficiaryDetails }: any = useSelector((state: any) => state.fetch_Beneficiaries_And_Policy_Details);
	useEffect(() => {
		if (!beneficiaryDetails && localStorage.getItem("accessToken"))
			fetchBeneficiaryDetails()
	}, [])
	const fetchBeneficiaryDetails = async () => {
		const accessTokenString = localStorage.getItem('accessToken');
		const maidString = localStorage.getItem('maid');
		const payload: beneficiaryReqPayload = {
			accessToken: accessTokenString,
			maid: maidString,
		};
		dispatch(fetch_Beneficiaries_And_Policy_Details(payload));
	}

	useEffect(() => {
		initializeGA();
	}, [])


	return (
		<HelmetProvider>
			<div>
				<Helmet>
					<title>{config?.hostName}</title>
					<link href={theme[appTheme]?.fontSrc} rel="stylesheet" />
					{process.env.NODE_ENV.includes('maven') && <script src={process.env.REACT_APP_OOP_URL} async={true} defer={true} />}
					{!process.env.REACT_APP_ENVIRONMENT?.includes('lawton') && <script src={process.env.REACT_APP_NETWORK_HOSPITAL_COMPONENT} defer={true} />}
					{!process.env.REACT_APP_ENVIRONMENT?.includes('lawton') && <script src={process.env.REACT_APP_INTIMATION_URL} defer={true}></script>}
					{!process.env.REACT_APP_ENVIRONMENT?.includes('lawton') && <script src={process.env.REACT_APP_CLAIM_SUBMISSION} defer={true}></script>}
					{/* <script src={process.env.REACT_APP_BANK_UPLOAD} defer={true}></script> */}
					{process.env.NODE_ENV.includes('maven') && <script src={process.env.REACT_APP_KYC_URL} defer={true}></script>}
					{process.env.NODE_ENV.includes('maven') && <script src={process.env.REACT_APP_LINK_POLICY}></script>}
					<script src={process.env.REACT_APP_ELIGIBLITY_URL}></script>
				</Helmet>
				<ThemeProvider theme={theme[appTheme]}>
					
					<Toaster position="bottom-center"
						toastOptions={{
							className: 'error-new-popup',
							duration: 30000,
						}}
						containerStyle={{
							left: 0,
							right: 0,
							zIndex: 999999
						}}
					/>
					<GlobalStyles />
					<RouteLoader />
				</ThemeProvider>
			</div>
		</HelmetProvider>
	);
}

export default App;
